import React from 'react';
import AwardDocument from './documents/AwardDocument';
import PatentDocument from './documents/PatentDocument';
import PermissionDocument from './documents/PermissionDocument';

const PatentForm = () => {
    return (
        <div>
            <PatentDocument />
            <AwardDocument />
            <PermissionDocument />
        </div>
    );
};

export default PatentForm;
